(function () {
    "use strict";
    angular.module("cardFrontConsumer.areas.check-balance.register-card", []);
}());